<template>
  <div>
    <template v-if="cocurricularReqs && cocurricularReqs.length > 0">
      <div class="row result_row" v-for="(career, index) in cocurricularReqs" style="border-bottom: solid 1px #e6e6e6;">
        <div class="col-3 thumbnail_container">
          <div @click.stop="launch(career)" class="thumbnail_container_inner">
            <template v-if="career.thumbnailURI">
              <img class="thumb_img" v-bind:src="career.thumbnailURI" alt="Img" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
            </template>
            <template v-else>
              <div class="default-thumb">
                <div class="txt-bx" v-html="setTitleInitials(career.title)"></div>
              </div>
            </template>
          </div>

          <div class="more_details">
            <div class="program_desc">
              <a href="javascript://" v-if="(career.entityType === 'CLUB')" @click="launch(career)">join the club</a>
              <a href="javascript://" v-if="(career.entityType === 'JOB')" @click="launch(career)">apply for job</a>
              <a href="javascript://" v-if="(career.entityType === 'EVENT')" @click="launch(career)">register for event</a>
            </div>
          </div>
        </div>

        <div class="col-9 entity_details">
          <div class="row entity_title">
            <span @click.stop="launch(career)" class="title ace_sec_txt" :id="'entityName_' + index" :aria-label="career.title">{{career.title}}</span>

            <b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
              <div class="title_container">
                {{career.title}}
              </div>
            </b-popover>
            <div :id="'entityNameContainer_' + index" class="title_container_popup"></div>
          </div>
          <div class="row" :id="'entityDesc_' + index" v-if="career.description">
             <span class="desc_txt">{{ career.description }}</span>
          </div>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'program-cocurricular',
    props: ['pathwayId'],
    data () {
      return {
        cocurricularReqs: []
      }
    },
    async mounted () {
      this.cocurricularReqs = await this.loadProgramCocurricular(this.pathwayId)
    },
    methods: {
      ...mapActions([
        'loadProgramCocurricular'
      ]),
      launch (object) {
        if (object.externalURI) {
          window.open(object.externalURI, '_blank')
        }
      },
      setTitleInitials (entityTitle) {
        if (!entityTitle) {
          return ' '
        }
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      }
    }
  }
</script>

<style scoped>
  .default-thumb {
    cursor: pointer;
    background-color: #34b2ff;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .default-thumb .txt-bx {
    overflow: hidden;
    height: 44px;
    font-size: 30px;
    text-align: center;
    font-weight: 500;
    letter-spacing: 20px;
    color: #fff;
    font-family: ibmPlex_MnBd;
    text-transform: uppercase;
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-width: 96px;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramCocurricular.vue